export const Gpl=
[
    { "name" :"No Level"},
    { "name" :"Bronze"},
    { "name" :"Silver"},
    { "name" :"Gold"},
    { "name" :"Platinum"},
]

  
 


